import { Action, Dispatch } from 'redux'
import { db } from 'firebase/index'
import { CampaignType } from 'types/campaign'
import { confirmCampaignAction } from 'reducks/campaign/actions'

const fetchCampaign = (campaignId: string) => {
  return async (dispatch: Dispatch<Action>) => {
    const campaign = await db
      .collection('campaigns')
      .doc(campaignId)
      .get()
      .then((snapshot) => {
        if (!snapshot.exists) return undefined
        const data = snapshot.data() as CampaignType
        data.campaign_id = campaignId
        return data
      })
      .catch((error) => {
        console.error(error)
        return undefined
      })
    if (!campaign) return
    dispatch(confirmCampaignAction(campaign))
  }
}

export default fetchCampaign
